import React, {useMemo} from 'react';
import {classes, style} from './google-map-view.st.css';
import {LocationCoordinates, Values} from "@wix/devzai-utils-common";
import {cssOverlay} from "../css-common/css-common";

export const GoogleMapViewDisplayMode = {
    Static: 'Static',
    InteractiveReadOnly: 'InteractiveReadOnly'
}

export type GoogleMapViewDisplayMode = Values<typeof GoogleMapViewDisplayMode>;

export const GoogleMapView = React.memo(function GoogleMapView(
    props: GoogleMapView.Props
) {
    const {
        locationCoordinates: {
            latitude,
            longitude
        },
        languageCode = 'en',
        displayMode,
        className,
        zoom,
        ...htmlAttributes
    } = props;

    const mapSrc = useMemo(() =>
            `https://maps.google.com/maps?q=${latitude},${longitude}&z=${zoom}&hl=${languageCode}&output=embed`,
        [latitude, longitude, zoom, languageCode]
    );

    const isStaticMode = displayMode === GoogleMapViewDisplayMode.Static;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <iframe
                title={`Map view at ${latitude},${longitude}`}
                className={classes.iframe}
                src={mapSrc}
                loading="lazy"
                referrerPolicy="no-referrer"
                scrolling="no"
            >
            </iframe>
            {isStaticMode && (<div className={style(classes.overlay, cssOverlay())} />)}
        </div>
    );
});

export namespace GoogleMapView {
    export interface Props extends React.HTMLAttributes<any> {
        locationCoordinates: LocationCoordinates,
        zoom: number,
        languageCode?: string;
        displayMode: GoogleMapViewDisplayMode;
    }
}